import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

export const useSaleLocation = () => {
  return useQuery({
    queryKey: ["checkSaleLocation"],
    queryFn: async () => {
      const res = await api().gersCheckSaleLocation();
      return res.data;
    },
    enabled: true,
  });
};
